<script>
    import InputPassword from "./InputPassword.svelte";

    export let pin;
    export let placeholder = 'Bitte geben Sie Ihre PIN ein.';
    export let showPwLabel = 'PIN anzeigen';
    export let hidePwLabel = 'PIN verbergen';
    export let invalid = false;


    $: pin, pinInputChanged();

    function pinInputChanged() {
        invalid = false;
    }

</script>

<InputPassword
        bind:pw={pin}
        formFeedback="Falsche PIN, bitte geben Sie die PIN erneut ein."
        {invalid}
        {placeholder}
        {showPwLabel}
        {hidePwLabel}
        {...$$restProps}
/>
